const SETTLEMENT_CALCULATION_MODES = {
  BY_VARIANTS: 1,
  GLOBAL: 2,
};

export default SETTLEMENT_CALCULATION_MODES;